var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpMarkerImageSrcUnselect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0365 33.6068C16.6107 34.1448 16.2544 34.6615 16 35.0516C15.7456 34.6615 15.3893 34.1448 14.9635 33.6068C14.5237 33.0513 14.0026 32.464 13.4362 31.969C12.8751 31.4786 12.2399 31.0525 11.5696 30.8577C5.16748 28.9516 0.5 23.0202 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 23.0202 26.8325 28.9516 20.4303 30.8577C19.7601 31.0525 19.1249 31.4786 18.5638 31.969C17.9974 32.464 17.4763 33.0513 17.0365 33.6068Z",
    fill: "white",
    stroke: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9375 22.5621L7.9375 15.4371H10.9375V10.9371L21.0625 10.9371V15.4371H24.0625V22.5621H17.6875V20.4996C17.6875 19.5676 16.932 18.8121 16 18.8121C15.068 18.8121 14.3125 19.5676 14.3125 20.4996V22.5621H7.9375ZM9.0625 21.4371H13.1875V20.4996C13.1875 18.9463 14.4467 17.6871 16 17.6871C17.5533 17.6871 18.8125 18.9463 18.8125 20.4996V21.4371H22.9375V16.5621H19.9375L19.9375 12.0621L12.0625 12.0621V16.5621H9.0625V21.4371Z",
    fill: "#FFB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0625 13.7496L24.0625 15.4371L22.9375 15.4371V13.7496H24.0625Z",
    fill: "#FFB800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0625 13.7496L9.0625 15.4371H7.9375L7.9375 13.7496H9.0625Z",
    fill: "#FFB800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0625 13.7496V15.9996H13.9375V13.7496H15.0625Z",
    fill: "#FFB800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0625 9.24957V10.9371H13.9375V9.24957L15.0625 9.24957Z",
    fill: "#FFB800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0625 13.7496V15.9996H16.9375V13.7496H18.0625Z",
    fill: "#FFB800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0625 9.24957V10.9371H16.9375V9.24957L18.0625 9.24957Z",
    fill: "#FFB800"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0625 9.24957V10.9371L19.9375 10.9371V9.24957L21.0625 9.24957Z",
    fill: "#FFB800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0625 9.24957V10.9371L10.9375 10.9371L10.9375 9.24957L12.0625 9.24957Z",
    fill: "#FFB800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpMarkerImageSrcUnselect);
export default __webpack_public_path__ + "static/media/expMarkerImageSrc_unselect.63d3697e995445d7248d0d54d7915849.svg";
export { ForwardRef as ReactComponent };